import { Constants } from '@leverege/molten'

import CycleTimeMonitoringScreen from './CycleTimeMonitoringScreen'
import EventsTableScreen from './EventsTableScreen'
import HeadCountScreen from './HeadCountScreen'
import PlyLayerShopFloorScreen from './PlyLayerShopFloorScreen'

export default {
  install( molten ) {
    molten.addPlugin( Constants.BLUEPRINT_RELATIONSHIP_PROCESSOR, CycleTimeMonitoringScreen )
    molten.addPlugin( Constants.BLUEPRINT_RELATIONSHIP_PROCESSOR, EventsTableScreen )
    molten.addPlugin( Constants.BLUEPRINT_RELATIONSHIP_PROCESSOR, HeadCountScreen )
    molten.addPlugin( Constants.BLUEPRINT_RELATIONSHIP_PROCESSOR, PlyLayerShopFloorScreen )
  }
}
